import { render, staticRenderFns } from "./cButton.vue?vue&type=template&id=896bcda6&scoped=true"
import script from "./cButton.vue?vue&type=script&lang=js"
export * from "./cButton.vue?vue&type=script&lang=js"
import style0 from "./cButton.vue?vue&type=style&index=0&id=896bcda6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896bcda6",
  null
  
)

export default component.exports